import { Grid, Divider, CardActions, Button, Typography } from "@mui/material";
import { getUserClaims } from "features/application/application-slice";
import { get_customer_settings, get_customer_settings_as_admin } from "features/auto-thunks";
import { get_customerAdministrator, get_selected_customerAdministrator } from "features/customerAdministrator/customerAdministrator-slice";
import { get_selected_customerSettings } from "features/customerSettings/customerSettings-slice";
import { get_customerSettings } from "features/customerSettings/customerSettings-slice";
import { useEffect } from "react"
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { gridSpacing } from 'store/constant';
import TitleService from "title-service";
import MainCard from "ui-component/cards/MainCard";
import RedQuickQRCode from "./RedQuickQRCode";
import SubCard from "ui-component/cards/SubCard";
import Busy from "./Busy";

export default function CustomerAdministratorComponent(props: any) {
    const claims = useSelector(getUserClaims);
    const customerSettings = useSelector(get_selected_customerSettings);
    const customerAdministrator = useSelector(get_selected_customerAdministrator);
    useEffect(() => {
        if (claims?.customerAdministrator) {
            dispatch(get_customer_settings_as_admin({
                customerAdministratorId: claims?.customerAdministrator,
                userId: claims?.user
            }))
        }
    }, [claims?.customerAdministrator]);

    return <>
        <Grid container spacing={gridSpacing}>
            <Busy />
            <Grid item xs={6}>
                <Grid container direction="column" spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h2" color="textSecondary">
                            {TitleService('Name')}: {customerSettings?.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h2" color="textSecondary">
                            {TitleService('Web domain')}: {customerSettings?.domain}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h2" color="textSecondary">
                            {TitleService('Code')}: {customerSettings?.connectionCode}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <RedQuickQRCode value={customerSettings?.connectionCode} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </>
}